import { useState } from 'react';
import './Pages.css';
import './Info.css';

const INSTAGRAM = 'https://instagram.com/zairecolor';

function Info() {
    const [showEmail, setShowEmail] = useState(false);
    const user = 'admin';
    const domain = 'zairecolor.com';
    const email = user + '@' + domain;

    return (
        <div className="page">


            <div className="info-layout">
                <div className="info-photo">
                    <img src="/images/about/zaire-folson.webp" alt="ZaireColor" />
                </div>

                <div className="info-body">
                    <p className="info-bio">
                        
                        A colorist based in Atlanta, Georgia with over five years of experience in the film industry. Zaire Folson is known for his dedication to creating subject-appropriate color and taking an intimate approach to meeting the unique needs of a production. 
                        <br /><br />
                        Deriving his principles as a colorist from his life as a Christian but also as a former classical violist, he sees an opportunity to express, amplify, and shape each other&rsquo;s ideas through the medium of film.
                    
                    </p>

                    <div className="info-contact">
                        <h2 className="info-contact-heading">Contact</h2>
                        <p>
                            For inquiries,{' '}
                            <span
                                className="info-email-link"
                                onClick={() => setShowEmail(true)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') setShowEmail(true);
                                }}
                                role="button"
                                tabIndex={0}
                            >
                                send an email
                            </span>
                            .
                        </p>
                        {showEmail && (
                            <p className="info-email-reveal">
                                <a href={'mailto:' + email}>{email}</a>
                            </p>
                        )}
                        <p>
                            <a
                                className="info-inline-link"
                                href={INSTAGRAM}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <svg className="info-ig-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6"/>
                                </svg>
                                {' @zairecolor'}
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Info;
